/* icon/UI 24px/Star (ratings, reviews).svg: width 24px x height 24px */
export default class DlsIconStar extends HTMLElement {
  static define(tagName = 'dls-icon-star') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path fill="currentColor" d="M12 18.584L5.82 22 7 14.764 2 9.639l6.91-1.055L12 2l3.09 6.584L22 9.639l-5 5.125L18.18 22 12 18.584z"/></svg>`;
  }
}
DlsIconStar.define();
